import React from "react";
import { Link } from "react-router-dom";
import "../styles/Research1.css";
import "../styles/Navbar.css";

import headerborder from "../assets/images/bordder-line.svg";
import researchimage from "../assets/images/research-1.svg";
import researchimage4 from "../assets/images/research-4.svg";
import fullreport from "../assets/images/full-report-icon.svg";
import reasearchcardborder from "../assets/images/research-card-border.svg";
import content2 from "../assets/images/content2.svg";
import analytics2 from "../assets/images/analytics-1-research-2.png";
import analytics3 from "../assets/images/analytics-2-research-2.png";
import tangoLogo from "../assets/logos/Tango.png";

const contentParagraph1 = "In the aftermath of the COVID-19 pandemic, IHEMA Research Team Ltd. was subcontracted by TANGO International to support the Rapid Review of the Mastercard Foundation COVID-19 Recovery and Resilience Program (CRRP Rwanda). This evaluation was implemented during a critical recovery period and required the rapid generation of credible evidence to inform adaptive program decision-making.";

const contentParagraph2 = "IHEMA Research Team led all field-based evaluation activities, including the design and delivery of enumerator training, supervision of qualitative data collection, and coordination across multiple implementation sites. The team applied rigorous qualitative methodologies to document recovery and resilience outcomes among diverse beneficiary groups, including youth, small business owners, and community-level organizations affected by pandemic-related economic disruption.";

const contentParagraph3 = "A core contribution of IHEMA was the development of structured qualitative data matrices that enabled systematic synthesis of interviews and focus group discussions. This approach supported the identification of key patterns, implementation strengths, emerging challenges, and unintended effects of the program. Findings were triangulated with quantitative data through close collaboration with TANGO International researchers and informed the final evaluation report and stakeholder presentations delivered to the Mastercard Foundation and partners.";

const Research2 = () => {
    // Asset paths from src/assets folder


    return (
        <div className="research-page">
            {/* Research Content */}
            <div className="Research1-container">
                <div className="research-heading-container">
                    <img src={headerborder} alt="headerborder" className="headerborder" />
                    <div className="research-content-wrapper">
                        <div className="inner-research">
                            <div className="research-header-content">
                                <div>
                                    <p className="research-heading">
                                        Rapid review of the Mastercard Foundation
                                    </p>
                                    <p className="research-heading">
                                        COVID-19 Recovery and Resilience Program (CRRP Rwanda)
                                    </p>
                                </div>
                                <img src={tangoLogo} alt="Tango Logo" className="tango-logo" />
                            </div>
                            <p className="date">September - December 2024</p>
                            <p className="partnership">
                                Partnership: IHEMA Research Team & Mastercard Foundation
                            </p>
                            <p className="research-role-detail">
                                <span className="role-label">IHEMA's Role:</span>
                                <span className="role-badge">Data Collection &amp; Reporting</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="content-container">
                    <p className="content-paragraph">
                        {contentParagraph1}
                    </p>
                    <p className="content-paragraph">
                        {contentParagraph2}
                    </p>
                    <p className="content-paragraph">
                        {contentParagraph3}
                    </p>
                    <img src={content2} alt="content" className="content-image" />
                    <div className="analytics">
                        <img src={analytics2} alt="Analytics" className="analytics" />
                        <img src={analytics3} alt="Analytics" className="analytics" />
                    </div>
                </div>
                <div className="research-card-container">
                    <img src={reasearchcardborder} alt="headerborder" className="research-card-border" />
                    <div className="outer-container">
                        <p className="more-assessments">More Assessments</p>
                        <div className="cards-container">
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        USDA McGovern-Dole Grant: Home Grown School Feeding Program -
                                        Phase II Endline & Phase III Baseline
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mcgovern-dole" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        Impact study of World Vision Rwanda programs focusing on
                                        community development and educational initiatives
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src="https://res.cloudinary.com/dsxiw1bop/image/upload/v1770284459/research-3_pu8jhx.svg"
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/world-vision" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                            <div className="research-card">
                                <div className="research-card-info">
                                    <p className="research-card-paragraph">
                                        USDA McGovern-Dole Grant: Home Grown School Feeding Program -
                                        Phase II Midterm Evaluation
                                    </p>
                                    <div className="research-role-tag">
                                        <span className="role-label">IHEMA's Role:</span>
                                        <span className="role-value">Data Collection &amp; Reporting</span>
                                    </div>
                                </div>
                                <img
                                    src={researchimage4}
                                    alt="research-card"
                                    className="research-card-image"
                                />
                                <Link to="/research/mcgovern-dole-midterm" className="read-more-link">
                                    <img
                                        src={fullreport}
                                        alt="full report"
                                        className="full-report"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Research2;
